@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.modal-body {
  padding: 15px;
}

.dropdown {
  display: block;
  width: 100%;

  > button {
    font-weight: 400;
  }
}

.loading-indicator {
  height: 330px;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}

.instructions {
  color: var(--default--text-color--3);
}

.map-requested-service-modal {
  width: 450px;
}
